export default {
  static_qr_id: 'Número de QR estático',
  create_static_qr: 'Crear código QR estático',
  qr_thumbnail: 'Miniaturas del código QR',
  qr_code_detail: 'Detalle del código QR estático',
  qr_link: 'Enlace del código QR',
  tag: 'Etiqueta',
  enter_remark: 'Ingrese una nota',
  enter_tag: 'Ingrese una etiqueta',
  download_qr_code: 'Descargar código QR estático',
  example: 'Ejemplo (solo como referencia):',
  view_transaction_details: 'Ver detalles de la transacción',
}
